export const MOBILE_WIDTH = 480;
export const TRANSCRIPT_EXPIRY_HIDE_TIME = 1000 * 59 * 60; // 59 mins -> ms

export const DEFAULT_PRIMARY_COLOR = '#029081';
export const DEFAULT_SECONDARY_COLOR = '#E0F1F0';
export const DEFAULT_TEXT_COLOR = '#000';

export const LINK_COLOR = '#EA555F';
